import {Box, Typography} from '@viptech/react-components'
import SlideTypography from 'src/components/SlideTypography'
import {FaceDetection} from 'src/services/api'
import {formatDateTime} from 'src/utilities/datetimeUtils'
import {pickStrongerColor} from 'src/utilities/pickStrongerColor'
import PhotoCard from './PhotoCard'

interface Props {
  onClick: (faceDetection: FaceDetection) => void
  faceDetection: FaceDetection
  cameraName?: string
  debug: boolean
}

export function PhotoFrame({faceDetection, cameraName, onClick, debug}: Props) {
  const handleColors = () => {
    let borderSize = '1'
    let borderColor = '#D0D5DD'
    let backgroundColor = '#D0D5DD20'
    let color = '#344054'

    const colors = faceDetection.activatedActions.map((a) => a.actionColor).filter((color): color is string => color !== undefined && color !== null)
    const hasColorEmphasis = colors.length > 0

    if (colors.length > 0) {
      const strongerColor = pickStrongerColor(colors)
      borderSize = '2'
      borderColor = strongerColor
      backgroundColor = strongerColor + '20'
      color = strongerColor
    }
    const border = `${borderSize}px solid ${borderColor}`

    return {border, backgroundColor, color, hasColorEmphasis}
  }

  return (
    <Box
      width='fit-content'
      height='fit-content'
      padding='8px'
      border={handleColors().border}
      backgroundColor={handleColors().backgroundColor}
      onClick={() => onClick(faceDetection)}
      style={{cursor: 'pointer'}}>
      <Box width='128px' display='flex' rowGap='8px' direction='column'>
        <SlideTypography variant='label' size='12px' weight={!handleColors().hasColorEmphasis ? 500 : 700} color={handleColors().color}>
          {cameraName ?? 'DESCONHECIDO'}
        </SlideTypography>
        <PhotoCard
          width='128px'
          height='136px'
          src={`${process.env.REACT_APP_CROPPED_IMAGES_BASE_URL}/${faceDetection.cropImageKey}`}
          style={{cursor: 'pointer'}}
        />

        <Box>
          <SlideTypography variant='label' size='12px' weight={!handleColors().hasColorEmphasis ? 500 : 700} color={handleColors().color}>
            {!debug ? (faceDetection.face?.name ?? 'DESCONHECIDO') : `FaceId: ${faceDetection.face?.id}`}
          </SlideTypography>
          <Box display='flex' justify='space-between'>
            <Typography variant='label' size='12px'>
              {formatDateTime(faceDetection.createdAt).formattedDate}
            </Typography>
            <Typography variant='label' size='12px'>
              {formatDateTime(faceDetection.createdAt).formattedTime}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
